import { eventBridgeService, EVENT_TYPES } from './eventService';
import { connectionRegistryService } from './connectionRegistryService';

let initialized = false;
const subscriptions = [];

function subscribe(eventType, handler) {
  const subscription = eventBridgeService.subscribe(eventType, handler);
  subscriptions.push(subscription);
}

function resolveEntityId(eventData, typedKey) {
  return eventData[typedKey] || eventData.id || null;
}

async function handleEntityDeleted(eventData, entityType, typedKey) {
  const { userId, tripId } = eventData;
  const entityId = resolveEntityId(eventData, typedKey);
  if (!userId || !tripId || !entityId) {
    console.warn('[ConnectionRegistry] Skipping entity delete purge — missing payload fields', {
      entityType,
      userId,
      tripId,
      entityId
    });
    return;
  }

  try {
    await connectionRegistryService.removeAllLinksForEntity(userId, tripId, entityType, entityId);
  } catch (error) {
    console.error(`[ConnectionRegistry] Failed to purge links for deleted ${entityType} ${entityId}:`, error);
  }
}

export function initConnectionRegistryServices() {
  if (initialized) {
    return;
  }

  subscribe(EVENT_TYPES.PLACE_DELETED, (eventData) =>
    handleEntityDeleted(eventData, 'place', 'placeId')
  );
  subscribe(EVENT_TYPES.DAY_DELETED, (eventData) =>
    handleEntityDeleted(eventData, 'day', 'dayId')
  );
  subscribe(EVENT_TYPES.ACCOMMODATION_DELETED, (eventData) =>
    handleEntityDeleted(eventData, 'accommodation', 'accommodationId')
  );
  subscribe(EVENT_TYPES.TRAVEL_DELETED, (eventData) =>
    handleEntityDeleted(eventData, 'travel', 'travelId')
  );
  subscribe(EVENT_TYPES.DOCUMENT_DELETED, (eventData) =>
    handleEntityDeleted(eventData, 'document', 'documentId')
  );

  initialized = true;
  console.log('[ConnectionRegistry] Services initialized');
}

export function resetConnectionRegistryServicesForTests() {
  subscriptions.forEach((subscription) => {
    if (subscription && typeof subscription.unsubscribe === 'function') {
      subscription.unsubscribe();
    }
  });
  subscriptions.length = 0;
  initialized = false;
}
